export const BAA_SIGN_USER_SIGN = 'BaaUserToSign';
export const BAA_SIGN_SEND_TO_OTHER_PRACTICE_USER =
  'BaaSendToOtherPracticeUser';
export const BAA_SIGN_USER_DECLINE = 'BaaUserDeclined';
export const BAA_SIGN_PRACTICE_WITH_SEPARATE_BAA = 'BaaPracticeWithSeparateBaa';
export const BAA_OTHER_PERSON_WILL_SIGN = 'BaaOtherPersonWillSign';
